// removed by extract-text-webpack-plugin
module.exports = {"formInput":"styles__formInput___2soJO","formTextArea":"styles__formTextArea___1Dz68"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/sent-message-panel/note-form/styles.css
// module id = 1100
// module chunks = 0